import { ConnectionFTPInterface, ConnectionInterface } from '@interface/connection/connection.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialConnectionsState: BaseStoreInterface<
  Record<string, ConnectionInterface>,
  ConnectionFTPInterface
> = {
  ...BaseStoreStructure,
  data: {},
  meta: {
    endpoint: '',
    username: '',
    password: '',
  },
};
